<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-1/2">
                <vs-card class="cardx">
                    <div slot="header">
                        <h3>Inbound Delivery</h3>
                    </div>
                    <e-charts autoresize :options="inbound_pie" auto-resize />
                </vs-card>
            </div>
            <div class="vx-col w-1/2">
                <vs-card class="cardx">
                    <div slot="header">
                        <h3>Outbound Delivery</h3>
                    </div>
                    <e-charts autoresize :options="outbound_pie" auto-resize />
                </vs-card>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-1/2">
                <vs-card class="cardx">
                    <div slot="header">
                        <h3>Good Receiving</h3>
                    </div>
                    <e-charts autoresize :options="gr_pie" auto-resize />
                </vs-card>
            </div>
            <div class="vx-col w-1/2">
                <vs-card class="cardx">
                    <div slot="header">
                        <h3>Delivery Order</h3>
                    </div>
                    <e-charts autoresize :options="do_pie" auto-resize />
                </vs-card>
            </div>
        </div>
    </div>
</template>

<script>
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";

export default {
    components: {
        ECharts,
    },
    data() {
        return {
            isLoading: false,
            inbound_pie: {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                    data: [
                        "Unreceived",
                        "Partially Received",
                        "Fully Received",
                        "Partially Checked",
                        "Fully Checked",
                        "Partially Putaway",
                        "Fully Putaway",
                    ],
                },
                series: [
                    {
                        name: "Documents",
                        type: "pie",
                        radius: "55%",
                        center: ["50%", "60%"],
                        color: ["#EA5455", "#FF9F43", "#28C76F"],
                        data: [
                            {
                                value: 0,
                                name: "Unreceived",
                            },
                            {
                                value: 0,
                                name: "Partially Received",
                            },
                            {
                                value: 0,
                                name: "Fully Received",
                            },
                        ],
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            },
            outbound_pie: {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                    data: [
                        "Uncommitted",
                        "Partially Committed",
                        "Fully Committed",
                    ],
                },
                series: [
                    {
                        name: "Outbound Delivery",
                        type: "pie",
                        radius: "55%",
                        center: ["50%", "60%"],
                        color: ["#EA5455", "#FF9F43", "#28C76F"],
                        data: [
                            {
                                value: 0,
                                name: "Uncommitted",
                            },
                            {
                                value: 0,
                                name: "Partially Committed",
                            },
                            {
                                value: 0,
                                name: "Fully Committed",
                            },
                        ],
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            },
            gr_pie: {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                    data: [
                        "Draft",
                        "Partially Checked",
                        "Fully Checked",
                        "Already Received",
                        "Partially Putaway",
                        "Full Putaway",
                    ],
                },
                series: [
                    {
                        name: "Good Receiving",
                        type: "pie",
                        radius: "55%",
                        center: ["50%", "60%"],
                        color: [
                            "#FF9F43",
                            "#28C76F",
                            "#EA5455",
                            "#87ceeb",
                            "#7367F0",
                            "#9b59b6",
                        ],
                        data: [
                            {
                                value: 0,
                                name: "Draft",
                            },
                            {
                                value: 0,
                                name: "Partially Checked",
                            },
                            {
                                value: 0,
                                name: "Fully Checked",
                            },
                            {
                                value: 0,
                                name: "Already Received",
                            },
                            {
                                value: 0,
                                name: "Partially Putaway",
                            },
                            {
                                value: 0,
                                name: "Full Putaway",
                            },
                        ],
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            },
            do_pie: {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                    data: [
                        "Unallocated",
                        "Partially Pick Allocated",
                        "Fully Pick Allocated",
                        "Partially Pick Confirmed",
                        "Fully Pick Confirmed",
                        "Good Issued",
                    ],
                },
                series: [
                    {
                        name: "Delivery Order",
                        type: "pie",
                        radius: "55%",
                        center: ["50%", "60%"],
                        color: [
                            "#FF9F43",
                            "#28C76F",
                            "#EA5455",
                            "#87ceeb",
                            "#7367F0",
                            "#9b59b6",
                        ],
                        data: [
                            {
                                value: 0,
                                name: "Unallocated",
                            },
                            {
                                value: 0,
                                name: "Partially Pick Allocated",
                            },
                            {
                                value: 0,
                                name: "Fully Pick Allocated",
                            },
                            {
                                value: 0,
                                name: "Partially Pick Confirmed",
                            },
                            {
                                value: 0,
                                name: "Fully Pick Confirmed",
                            },
                            {
                                value: 0,
                                name: "Good Issued",
                            },
                        ],
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            },
        };
    },
    watch: {
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
    },
    methods: {
        fetchData() {
            this.isLoading = true;
            this.$http
                .get("/dashboard/data")
                .then((res) => {
                    const outbound_data = [
                        {
                            value: res.data.outbound_data.uncommitted,
                            name: "Uncommitted",
                        },
                        {
                            value: res.data.outbound_data.partially_committed,
                            name: "Partially Committed",
                        },
                        {
                            value: res.data.outbound_data.fully_committed,
                            name: "Fully Committed",
                        },
                    ];

                    const inbound_data = [
                        {
                            value: res.data.inbound_data.unreceived,
                            name: "Unreceived",
                        },
                        {
                            value: res.data.inbound_data.partially_received,
                            name: "Partially Received",
                        },
                        {
                            value: res.data.inbound_data.fully_received,
                            name: "Fully Received",
                        },
                    ];

                    const gr_data = [
                        {
                            value: res.data.gr_data.draft,
                            name: "Draft",
                        },
                        {
                            value: res.data.gr_data.partially_checked,
                            name: "Partially Checked",
                        },
                        {
                            value: res.data.gr_data.fully_checked,
                            name: "Fully Checked",
                        },
                        {
                            value: res.data.gr_data.already_received,
                            name: "Already Received",
                        },
                        {
                            value: res.data.gr_data.partially_putaway,
                            name: "Partially Putaway",
                        },
                        {
                            value: res.data.gr_data.fully_putaway,
                            name: "Full Putaway",
                        },
                    ];

                    const do_data = [
                        {
                            value: res.data.do_data.unallocated,
                            name: "Unallocated",
                        },
                        {
                            value: res.data.do_data.partially_allocated,
                            name: "Partially Pick Allocated",
                        },
                        {
                            value: res.data.do_data.fully_allocated,
                            name: "Fully Pick Allocated",
                        },
                        {
                            value: res.data.do_data.partially_picked,
                            name: "Partially Pick Confirmed",
                        },
                        {
                            value: res.data.do_data.fully_picked,
                            name: "Fully Pick Confirmed",
                        },
                        {
                            value: res.data.do_data.good_issued,
                            name: "Good Issued",
                        },
                    ];

                    this.outbound_pie.series[0].data = outbound_data;
                    this.inbound_pie.series[0].data = inbound_data;
                    this.gr_pie.series[0].data = gr_data;
                    this.do_pie.series[0].data = do_data;
                })
                .catch((error) => console.log(error))
                .then(() => (this.isLoading = false));
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>